import React, { useCallback } from 'react';
import { useDirectoryItemContacts } from '../../../../data/hooks/directory/directoryHooks';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import resolvePath from '../../../../misc/resolvePath';
import ParticipantListItem from '../../../elements/ParticipantListItem/ParticipantListItem';
import ScheduleMeetingButton from '../../../elements/ScheduleMeetingButton/ScheduleMeetingButton';
import SectionHeader from '../../../elements/SectionHeader/SectionHeader';

const DirectoryItemContacts = (props) => {
    const { event, item } = props,
        i18n = useI18n(),
        contacts = useDirectoryItemContacts(event.id, item.id);

    const handleOpenParticipant = useCallback(
        (participant) => {
            const path = resolvePath(app.history.location.pathname, ['participants', participant.id || '-', participant.participant_id || '-'].join('/'));
            app.history.push(path);
        },
        [event, item]
    );

    if (!contacts.length) return null;

    return (
        <div className="whitebg">
            <SectionHeader className="content">{i18n['label.exhibitor.contacts']}</SectionHeader>
            {contacts.map((participant, i) => (
                <ParticipantListItem
                    key={i}
                    participant={participant}
                    tagName="div"
                    className="clickable"
                    onClick={() => handleOpenParticipant(participant)}
                    showUserDetails
                    rightContent={<ScheduleMeetingButton event={event} participant={participant} />}
                />
            ))}
        </div>
    );
};

export default DirectoryItemContacts;
